import React from "react";

function Chip({ children }) {
  return <span className="chip">{children}</span>;
}

const TYPE_LABEL = {
  MEETING: "Meetings",
  APPOINTMENT: "Appointments",
  PRESENTATION: "Presentations",
  EVENT: "Events",
};


export default function ScheduleDetail({ eventsForDay, event, onClose, onEdit }) {
  const list = Array.isArray(eventsForDay)
    ? [...eventsForDay] // Sorting is now handled in Calendar.js
    : (event ? [event] : []);

  const hasImportant = list.some(ev => ev.importance === true || ev.importance === "important");

  return (
    <aside className={`cal-detail ${hasImportant ? "cal-important" : ""}`}>
      <div className="cal-detail-head">
        <h3 className="card-title">Schedule Details</h3>
        <button className="btn-icon" onClick={onClose} aria-label="Close">✕</button>
      </div>

      <div className="cal-detail-list">
        {list.map((ev, idx) => {
          const start = new Date(ev.start);
          const end = new Date(ev.end);
          const isValidStart = start instanceof Date && !isNaN(start);
          const isValidEnd = end instanceof Date && !isNaN(end);

          return (
            <section
              key={ev.id || idx}
              className={`cal-detail-card ${ev.importance === true || ev.importance === "important" ? "is-important" : ""}`}

            >
              <div className="cal-detail-cardhead">
                <div className="cal-detail-title">{ev.title}</div>
                <div className="cal-detail-actions">
                  <button type="button" className="btn btn-link" onClick={() => onEdit && onEdit(ev)}>
                    Edit
                  </button>
                </div>
              </div>

              <div className="cal-detail-type">
                {(ev.importance === true || ev.importance === "important") && (
                  <span className="chip chip--important">Important ★</span>
                )}
                <span className="chip">{TYPE_LABEL[ev.type] || ev.type}</span>
              </div>

              <div className="cal-detail-section">
                <div className="cal-detail-label">When</div>
                <div className="cal-detail-text">
                  {isValidStart ? new Intl.DateTimeFormat('en-IN', { weekday: 'short', day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata' }).format(start) : "Invalid start date"} — {isValidEnd ? new Intl.DateTimeFormat('en-IN', { hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata' }).format(end) : "Invalid end date"}
                </div>
              </div>
              <div className="cal-detail-section">
                <div className="cal-detail-label">Location</div>
                <div className="cal-detail-text">
                  {ev.location_id || "—"}
                  {ev.room ? ` · ${ev.room}` : ""}
                </div>
              </div>

              {Array.isArray(ev.assignees) && ev.assignees.length > 0 && (
                <div className="cal-detail-section">
                  <div className="cal-detail-label">Team</div>
                  <div className="cal-detail-tags">
                    {ev.assignees.map((a, i) => (
                      <Chip key={i}>{typeof a === "string" ? a : (a.name || "Member")}</Chip>
                    ))}
                  </div>
                </div>
              )}

              {!!ev.notes && (
                <div className="cal-detail-section">
                  <div className="cal-detail-label">Notes</div>
                  <div className="cal-detail-text">{ev.notes}</div>
                </div>
              )}

              {ev.links && ev.links.trim() ? (
                <div className="cal-detail-section">
                  <div className="cal-detail-label">Links</div>
                  <div className="cal-detail-text">
                    <a
                      href={ev.links}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link"
                    >
                      {ev.links}
                    </a>
                  </div>
                </div>
              ) : null}
            </section>
          );
        })}
      </div>
    </aside>
  );
}
